import createLucideIcon from '../createLucideIcon';

const ChevronsRightLeft = createLucideIcon('ChevronsRightLeft', [
  ['path', { d: 'm20 17-5-5 5-5', key: '30x0n2' }],
  ['path', { d: 'm4 17 5-5-5-5', key: '16spf4' }],
]);

export default ChevronsRightLeft;
